(function largeimagectaScript($, Drupal) {
  Drupal.behaviors.largeimagecta = {
    attach(context) {
      // Simulates Drupal dialog behaviour using jQuery UI dialog.
      $('.pl .large-image-cta.has-video', context).each(function videoModal() {
        const $this = $(this);
        const id = `#${$(this).attr('id')}`;
        const video = `${id}--video`;
        const $link = $this.find('.js-video-trigger');
        $(video).addClass('visually-hidden');
        $(video).dialog({
          classes: {
            'ui-dialog': 'js-video-container'
          },
          autoOpen: false,
          width: '854px',
          modal: true
        });
        $link.attr('aria-haspopup', 'modal');
        $link.click(() =>
          $(video)
            .removeClass('visually-hidden')
            .dialog('open')
        );
      });
    }
  };
}(jQuery, Drupal));
